<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.attachment"
        :primary-fields="[ 'file.name', 'file.type', 'file.creator', 'created_at' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <AttachmentsTable
          ref="table"
          :carrier-id="$route.params.carrierId"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AttachmentsTable from '@/components/Application/Manage/Carriers/Attachments/Table'

export default {
  components: {
    Filters,
    AttachmentsTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'manage-carriers-carrier-attachments', params: { carrierId: this.$route.params.carrierId } }
      },
      filters: []
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
